import { useAppDispatch } from '~/store/hooks';
import api from '~/store/services/api';
import { CacheTag } from '~/store/services/CacheTag';
import { clinicalDataApi } from '~/store/services/clinicalData';

const usePatientCoveragesDispatch = () => {
  const dispatch = useAppDispatch();

  const resetPatientCoverages = (patientId: string) => {
    dispatch(
      api.util.invalidateTags([
        { id: patientId, type: CacheTag.PatientCoveragesById },
      ]),
    );
  };

  const removePatientCoverage = (
    patientCoverageId: string,
    patientId: string,
  ) => {
    const action = clinicalDataApi.util.updateQueryData(
      'getPatientCoverages',
      { patientId },
      (data) => {
        return data.filter(
          (coverage) => coverage.coverageExternalId !== patientCoverageId,
        );
      },
    );

    dispatch(action);
  };

  return {
    removePatientCoverage,
    resetPatientCoverages,
  };
};

export default usePatientCoveragesDispatch;
